import { render, staticRenderFns } from "./ConnectSupplier.vue?vue&type=template&id=976d6708&scoped=true&"
import script from "./ConnectSupplier.vue?vue&type=script&lang=js&"
export * from "./ConnectSupplier.vue?vue&type=script&lang=js&"
import style0 from "./ConnectSupplier.vue?vue&type=style&index=0&id=976d6708&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976d6708",
  null
  
)

export default component.exports